import {Component, Input} from '@angular/core';
import {AddressData} from '../../../interfaces/address-data';

/**
 * Generated class for the AdressDetailComponent component.
 */
@Component({
  selector: 'adress-detail',
  templateUrl: 'adress-detail.html',
  styleUrls: ['./adress-detail.scss']
})
export class AdressDetailComponent {

  @Input()
  address: AddressData;

  @Input()
  isEdit: boolean;

  constructor() {

  }
}
